const dados = {
facebook:"/",
insta:"/",
tel: "(11) 1234-5678",
whats: "(11) 11234-5678",
email: "email@emailshaped_end.com.br",
end: "Rua Nome ,Numero - Referencia CEP 00000-000 "
}

export default dados